import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function NotFoundPage() {
	const navigate = useNavigate();
	useEffect(() => {
		document.title = " Página no encontrada | Somnus";
		return () => { document.title = "Somnus"; };
	}, []);

	return (
		<div className="container-fluid d-flex flex-column align-items-center justify-content-center min-vh-100  font-n">
			<div className="text-center p-3" style={{ maxWidth: '500px' }}>
				<h1 className="fw-bold mb-2" style={{color: 'var(--dark-blue)', fontSize: '80px', letterSpacing: '-2px'}}>404</h1>

				<h3 className=" fw-bold mb-3" style={{ color: 'var(--font)' }}>¡Ups! Te has perdido</h3>

				<p className="text-muted mb-4">
					La página que buscas no existe, ha sido movida o nunca estuvo aquí.
					No te preocupes, puedes volver a navegar desde el inicio.
				</p>

				<div className="d-flex justify-content-center">
					<div className="btn-back-container">
						<button onClick={() => navigate(-1)}>
							<i className="ri-arrow-go-back-line d-inline d-md-none"></i><span className="d-none d-md-inline">Volver</span>
						</button>
					</div>
				</div>
			</div>
			<p className="mt-4 small text-muted">Somnus &copy; 2026</p>
		</div>
	);
}